// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'
import { push } from 'react-router-redux'
import { loadingToggler } from 'redux/modules/loading'
import handleCreatedProtectionProjectWithFailedAnalysisKickOff from './handleCreatedProtectionProjectWithFailedAnalysisKickOff'
import { assembleQuery } from 'helpers/api'

import {
  postCreateProtectionProject,
  saveProjectToDB,
} from 'helpers/api/project'

import {
  castToFloat,
  preventFormSubmission,
  throwSubmissionError,
} from 'helpers/reduxFormFunctions'

const createNewProject = (formValues, d, formProps) => dispatch => (
  dispatch(loadingToggler(
    async () => {
      // adds layer of validation for submit
      if (preventFormSubmission(formProps)) {
        return
      }

      const {
        defaultCompanyId,
        defaultContactId,
        pathIds,
        projectIds,
        projectName,
        rcnNumber,
        unitType,
      } = formValues

      const projectTypeId = castToFloat(formValues.projectTypeId)

      try {
        let projectId = null

        if (projectTypeId === ProjectTypeIdEnum.PROTECTION) {
          const query = assembleQuery([{
            field: 'rcnNumber',
            value: rcnNumber,
          }, {
            field: 'unitType',
            value: unitType,
          }])

          const { entity } = await postCreateProtectionProject(query)
          projectId = entity.projectId
        } else {
          const newProjectData = {
            defaultCompanyId,
            defaultContactId,
            pathIds,
            projectIds,
            projectName,
            projectTypeId,
            unitType,
          }

          const { entity } = await saveProjectToDB(newProjectData)
          projectId = entity.projectId
        }

        // NOTE - only one instance of the ProjectCreate form actually uses context modal
        // however this will not harm in the other workflows.
        // moreover, the other workflows should eventually use context modal too!
        formProps.closeContextModal()

        dispatch(push(`/project-management/${projectId}`))
      } catch (err) {
        console.warn(err)

        // there's this weird scenario in the Protection Project Pipeline, where the project can be created then fail to kick off an analysis.
        // this is because those two operations are separate transactions. When this situation happens, help the user out.
        if (err.message === `The Protection Project for RCN ${rcnNumber} was created but Analysis validation failed. See "Run Analysis" page for validation error messages.`) {
          // close the modal for this specific failure workflow.
          formProps.closeContextModal()
          return dispatch(handleCreatedProtectionProjectWithFailedAnalysisKickOff(rcnNumber))
        } else {
          throwSubmissionError(err)
        }
      }
    })
  )
)

export default createNewProject
